export default __webpack_public_path__ + "assets/profeature-panel-multiple.02572a9e644f7969715fffcdb37f7cb6.jpg";